<template>
  <div class="formbar formbar_phishing-check">
    <div class="formbar__container">
      <div class="formbar__bg">
        <ul class="formbar-fields">
          <li class="formbar-field formbar-field_input-url">
            <div class="field-input" :class="{'field-full': link}">
              <span class="label-description">Введите адрес ссылки</span>
              <input class="field-input__inner formbar__input"
                     required
                     placeholder="Введите адрес ссылки"
                     v-model="link"
                     @input="inputLink"
                     @keyup.enter="submit"
              >
            </div>
          </li>
          <li class="formbar-field formbar-field_button">
            <a
              class="formbar-field__button"
              :class="{'formbar-field__button_disabled': !link || linkSecurityStatus >= 4}"
              @click.prevent="submit"
              >
              <span>Проверить ссылку</span>
            </a>
          </li>
        </ul>
        <div class="formbar__message formbar__message_await" v-show="linkSecurityStatus >= 4">
          <img src="/packages/boxberry/theme/frontend/boxberryvue/src/assets/loader-circle.svg" />
          <p class="formbar__text formbar__text_await">Идет проверка...</p>
        </div>
        <div class="formbar__message formbar__message_failed" v-if="linkSecurityStatus === 3">
          <p class="formbar__text formbar__text_failed" v-for="(message, index) in errorMessages" :key="index">{{ message }}</p>
        </div>
        <div class="formbar__message formbar__message_success-safe" v-if="linkSecurityStatus === 2">
          <svg class="formbar__icon" width="24px" height="27px">
            <use xlink:href="#link-is-safe-icon"></use>
          </svg>
          <p class="formbar__text">
            <span class="formbar__text-bold">Ссылка безопасна.</span> Вы можете ей пользоваться без опасений.
          </p>
        </div>
        <div class="formbar__message formbar__message_success-unsafe" v-if="linkSecurityStatus === 1">
          <svg class="formbar__icon" width="21px" height="23px">
            <use xlink:href="#link-is-unsafe-icon"></use>
          </svg>
          <p class="formbar__text">
            <span class="formbar__text-bold">Внимание! Ненадежная ссылка!</span> Ее нет в нашей базе, вероятно, это мошенники!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require('axios');

export default {
  name: 'FormbarPhishingCheck',
  data() {
    return {
      // Состояния: 0 - пустое значение, 1 - ссылка небезопасна,
      // 2 - ссылка безопасна, 3 - произошла ошибка при запросе, 4 - ожидание проверки.
      linkSecurityStatus: 0,
      link: '',
      errorMessages: [],
    };
  },
  methods: {
    submit() {
      if (this.link) {
        this.linkSecurityStatus = 4;

        axios.get('/api/v1/check_url', {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            url: this.link,
          },
        }).then((response) => {
          if (response && response.data && typeof response.data.result === 'boolean') {
            if (response.data.result) {
              this.linkSecurityStatus = 2;
            } else {
              this.linkSecurityStatus = 1;
            }
          } else {
            this.linkSecurityStatus = 3;
          }
        }).catch((error) => {
          this.errorMessages = ['Произошла ошибка. Попробуйте повторить позже.'];
          if (error && error.response && error.response.status === 400 && error.response.data && error.response.data.messages) {
            this.errorMessages = error.response.data.messages;
          }
          this.linkSecurityStatus = 3;
        });
      }
    },
    inputLink() {
      this.linkSecurityStatus = 0;
    },
  },
  watch: {
    linkSecurityStatus(newValue) {
      this.$emit('updateLinkSecurityStatus', newValue);
    },
  },
};
</script>
<style lang="scss">
  @import 'FormbarPhishingCheck';
</style>
